import maestroLogoLight from '../../../images/logos/maestro_logo_mark_primary.svg';
import maestroLogoDark from '../../../images/logos/maestro_logo_mark_green.svg';

export const MaestroLogo = {
  LIGHT: maestroLogoLight,
  DARK: maestroLogoDark,
  DEFAULT: maestroLogoLight,
};
